<template>
  <main-page-component />
</template>

<script>
import MainPageComponent from '@/components/layout/MainPageComponent'
export default {
  components: { MainPageComponent },
}
</script>